import { render } from "./ContactBox.vue?vue&type=template&id=2adadd68"
import script from "./ContactBox.vue?vue&type=script&lang=js"
export * from "./ContactBox.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__